/** Semana ISO 8601 de una fecha: «2026-W42». */
export function isoWeek(d: Date): string {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = t.getUTCDay() || 7;
  t.setUTCDate(t.getUTCDate() + 4 - day);
  const yearStart = Date.UTC(t.getUTCFullYear(), 0, 1);
  const week = Math.ceil(((t.getTime() - yearStart) / 86400000 + 1) / 7);
  return `${t.getUTCFullYear()}-W${String(week).padStart(2, '0')}`;
}

export function shiftWeek(week: string, delta: number): string {
  const m = /^(\d{4})-W(\d{2})$/.exec(week);
  if (!m) throw new Error(`Semana inválida: ${week}`);
  // jueves de esa semana ISO
  const jan4 = new Date(Date.UTC(Number(m[1]), 0, 4));
  const mondayW1 = new Date(jan4);
  mondayW1.setUTCDate(jan4.getUTCDate() - ((jan4.getUTCDay() || 7) - 1));
  const thursday = new Date(mondayW1);
  thursday.setUTCDate(mondayW1.getUTCDate() + (Number(m[2]) - 1 + delta) * 7 + 3);
  return isoWeek(new Date(thursday.getUTCFullYear(), thursday.getUTCMonth(), thursday.getUTCDate()));
}

export const weekNumber = (week: string) => Number(week.slice(-2));

/** Semana de la reunión que usa una foto: la foto se cierra la víspera, así que cuenta el día siguiente. */
export const meetingWeek = (takenAt: string | Date) =>
  isoWeek(new Date(new Date(takenAt).getTime() + 86400_000));
